package ru.villawonka.app.presentation.screens.setup.compose.view

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Colors
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.theme.AppColors
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.outlinePrimary

@Composable
fun StepperView(
    currentStep: Int,
    stepCount: Int,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically
    ) {
        for (i in 1..stepCount) {
            val stepBoxBackgroundColor = if (currentStep == i) {
                MaterialTheme.colors.outlinedStepperBackgroundFocused
            } else {
                if (i < currentStep) {
                    MaterialTheme.colors.outlinedStepperBackgroundSelected
                } else {
                    MaterialTheme.colors.outlinedStepperBackgroundEnabled
                }
            }

            val stepTextColor = if (currentStep == i) {
                MaterialTheme.colors.outlinedStepperContentFocused
            } else {
                if (i < currentStep) {
                    MaterialTheme.colors.outlinedStepperContentSelected
                } else {
                    MaterialTheme.colors.outlinedStepperContentEnabled
                }
            }

            val stepBorderColor = if (currentStep == i) {
                MaterialTheme.colors.outlinedStepperOutlineFocused
            } else {
                if (i < currentStep) {
                    MaterialTheme.colors.outlinedStepperOutlineSelected
                } else {
                    MaterialTheme.colors.outlinePrimary
                }
            }

            Box(
                contentAlignment = Alignment.Center,
                modifier = Modifier
                    .background(
                        color = stepBoxBackgroundColor,
                        shape = RoundedCornerShape(150.dp)
                    )
                    .border(
                        width = 2.dp,
                        color = stepBorderColor,
                        shape = RoundedCornerShape(150.dp)
                    )
                    .size(56.dp)
            ) {
                Text(
                    text = i.toString(),
                    style = AppTextStyles.titleMediumBold,
                    color = stepTextColor
                )
            }
            if (i != stepCount) {
                Box(
                    modifier = Modifier
                        .background(
                            color = MaterialTheme.colors.outlinePrimary
                        )
                        .size(
                            width = 48.dp,
                            height = 2.dp,
                        )
                )
            }
        }
    }
}

private val Colors.outlinedStepperContentEnabled
    get() = if (isLight) AppColors.grayLight950 else AppColors.grayDark50

private val Colors.outlinedStepperContentFocused
    get() = if (isLight) AppColors.grayLight50 else AppColors.grayDark50

private val Colors.outlinedStepperContentSelected
    get() = if (isLight) AppColors.grayLight50 else AppColors.grayDark50

private val Colors.outlinedStepperBackgroundEnabled
    get() = if (isLight) AppColors.grayLight200 else AppColors.grayDark700

private val Colors.outlinedStepperBackgroundFocused
    get() = if (isLight) AppColors.blue500 else AppColors.blue500

private val Colors.outlinedStepperBackgroundSelected
    get() = if (isLight) AppColors.blue600 else AppColors.blue600

private val Colors.outlinedStepperOutlineEnabled
    get() = if (isLight) AppColors.grayLight300 else AppColors.grayDark600

private val Colors.outlinedStepperOutlineFocused
    get() = if (isLight) AppColors.blue500 else AppColors.blue500

private val Colors.outlinedStepperOutlineSelected
    get() = if (isLight) AppColors.blue400 else AppColors.blue400



